import { Settings } from './Settings';
//import { Math } from './Math';
import {
    VerifyNumericLimit_Btw_MinMax,
    VerifyNumericLimit_ByLimit,
    RoundValueASTM,
    RoundValueASTM_ValAsStr,
    Approximates,
    RemoveScientificNotation,
    GetDecimalsFromString,
    VpsCommodity,
    VpsGravityType,
    VpsTemperatureUnit,
    VpsQuantityUnit,
    VpsViscosityUnit
} from './FuelMath';

let KV50Array = [2.0, 2.1, 2.2, 2.3, 2.4, 2.5, 2.6, 2.7, 2.8, 2.9, 3, 3.2, 3.4, 3.6,
    3.8, 4, 4.2, 4.4, 4.6, 4.8, 5, 5.2, 5.4, 5.6, 5.8, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5,
    12, 12.5, 13, 13.5, 14, 14.5, 15, 15.5, 16, 16.5, 17, 17.5, 18, 18.5, 19, 19.5, 20, 21, 22, 23, 24, 25,
    26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 42, 44, 46, 48, 50, 52, 54, 56, 58, 60, 62,
    64, 66, 68, 70, 72, 74, 76, 78, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 210, 220,
    230, 240, 250, 260, 270, 280, 290, 300, 310, 320, 330, 340, 350, 360, 370, 380, 390, 400, 410, 420, 430,
    440, 450, 460, 470, 480, 490, 500, 510, 520, 530, 540, 550, 560, 570, 580, 590, 600, 610, 620, 630, 640,
    650, 700, 750, 800, 850, 900]

let EnglerArray = [1.141, 1.149, 1.158, 1.166, 1.175, 1.183, 1.191, 1.2, 1.208, 1.217, 1.225,
    1.242, 1.259, 1.275, 1.292, 1.309, 1.326, 1.343, 1.361, 1.381, 1.401, 1.418, 1.435, 1.451, 1.467, 1.483, 1.523,
    1.573, 1.608, 1.656, 1.703, 1.749, 1.794, 1.84, 1.885, 1.932, 1.977, 2.024, 2.074, 2.125, 2.175, 2.224, 2.275,
    2.329, 2.384, 2.44, 2.496, 2.547, 2.597, 2.651, 2.707, 2.762, 2.82, 2.878, 2.993, 3.109, 3.225, 3.345, 3.465,
    3.586, 3.706, 3.831, 3.957, 4.082, 4.208, 4.333, 4.458, 4.584, 4.709, 4.839, 4.97, 5.095, 5.221, 5.351, 5.607,
    5.863, 6.123, 6.384, 6.65, 6.911, 7.127, 7.392, 7.656, 7.92, 8.183, 8.447, 8.712, 8.976, 9.24, 9.503, 9.767,
    10.165, 10.432, 10.7, 12.037, 13.374, 14.71, 16.05, 17.39, 18.72, 19.98, 21.32, 22.65, 23.98, 25.31, 26.64,
    27.98, 29.31, 30.64, 31.97, 33.31, 34.64, 35.97, 37.3, 38.64, 39.97, 41.3, 42.63, 43.96, 45.3, 46.63, 47.96,
    49.29, 50.63, 51.96, 53.29, 54.62, 55.96, 57.29, 58.62, 59.95, 61.28, 62.62, 63.94, 65.28, 66.61, 67.95, 69.28,
    70.61, 71.92, 73.27, 74.61, 75.94, 77.27, 78.6, 79.94, 81.27, 82.6, 83.93, 85.26, 86.6, 93.3, 99.9, 106.6, 113.2, 119.9]

let RedwoodArray = [32.1, 32.4, 32.7, 33, 33.4, 33.7, 34, 34.3, 34.6, 34.9, 35.4, 36, 36.6,
    37.3, 38, 38.7, 39.4, 40.1, 40.9, 41.8, 42.6, 43.2, 43.9, 44.6, 45.4, 46.1, 47.3, 50.5, 53, 55, 57.3, 59.5,
    62, 65, 67, 70, 73, 76, 79, 82, 85, 88, 91, 94, 97, 100, 103, 106, 109, 112, 116, 120, 124, 128, 135, 143, 150,
    157, 164, 171, 178, 185, 192, 200, 207, 215, 223, 231, 239, 247, 255, 263, 270, 278, 292, 308, 328, 338, 354,
    370, 391, 407, 423, 439, 455, 471, 487, 503, 520, 537, 555, 573, 592, 612, 700, 780, 870, 965, 1055, 1150, 1240,
    1330, 1425, 1520, 1620, 1720, 1820, 1920, 2020, 2120, 2220, 2320, 2420, 2525, 2630, 2735, 2840, 2945, 3050,
    3160, 3270, 3380, 3490, 3600, 3710, 3820, 3930, 4040, 4150, 4260, 4370, 4408, 4590, 4700, 4810, 4920, 5030, 5140,
    5250, 5360, 5470, 5580, 5690, 5800, 5910, 6020, 6130, 6240, 6350, 6460, 6570, 7150, 7800, 8400, 9000, 9600]


let SSFArray = ["", "", "", "", "", "", "", "", "",
    "", "", "", "", "", "", "", "", "", "", "", "", "",
    "", "", "", "", "", "", "", "", "", "", "", "", "",
    "", "", "", "", "", "", "", "", "", "", "", "", "",
    "", "", "", "", "", "", "", "", "", "", "", "", "",
    "", "", "", "", "", "", "", "", "", "", "", "",
    21, 22, 23, 24, 25.1, 26, 27, 27.9, 28.8, 29.7, 30.6, 31.5, 32.4, 33.3, 34.2, 35.1, 36, 36.9, 37.8, 38.7, 39.6, 44.1,
    48.6, 53.2, 57.7, 62.3, 66.9, 71.5, 76.1, 80.8, 85.4, 90.1, 94.8, 99.4, 104.1, 108.8, 113.5, 118.2, 122.9, 127.6, 132.3,
    137, 141.7, 146.4, 151.1, 155.8, 160.5, 165.2, 169.9, 174.6, 179.4, 184.1, 188.8, 193.5, 198.2, 203, 208, 212, 217, 222,
    226, 231, 236, 241, 245, 250, 255, 259, 264, 269, 274, 278, 283, 288, 292, 297, 302, 307, 330, 354, 377, 401, 425]

let SSU122Array = [32.6, 33, 33.3, 33.7, 34, 34.3, 34.7, 35, 35.3, 35.7, 36, 36.7, 37.3, 38, 38.6,
    39.3, 39.9, 40.5, 41.2, 41.8, 42.4, 43.1, 43.7, 44.4, 45, 45.6, 47.2, 48.9, 50.5, 52.1, 53.8, 55.5, 57.2, 58.9, 60.7,
    62.4, 64.3, 66.1, 67.9, 69.8, 71.7, 73.6, 75.5, 77.5, 79.5, 81.5, 83.5, 85.5, 87.5, 89.6, 91.7, 93.8, 95.8, 98, 102,
    107, 111, 115, 120, 124, 128, 133, 137, 142, 146, 151, 155, 160, 164, 169, 173, 178, 182, 187, 196, 205, 215, 224, 233,
    242, 251, 261, 270, 279, 288, 297, 307, 316, 325, 334, 344, 353, 362, 371, 418, 464, 510, 557, 603, 650, 696, 742, 789,
    835, 881, 928, 974, 1021, 1067, 1113, 1160, 1206, 1253, 1299, 1345, 1392, 1438, 1484, 1531, 1577, 1623, 1670, 1716, 1762,
    1809, 1856, 1902, 1948, 1995, 2041, 2087, 2134, 2180, 2227, 2273, 2319, 2366, 2412, 2459, 2505, 2551, 2598, 2644, 2690,
    2737, 2783, 2830, 2876, 2922, 2969, 3015, 3247, 3479, 3711, 3943, 4175]

let SSU210Array = [29.5, 29.6, 29.7, 29.9, 30, 30.2, 30.3, 30.4, 30.6, 30.7, 30.8, 31.1, 31.3, 31.5,
    31.8, 32, 32.2, 32.5, 32.7, 32.9, 33.1, 33.3, 33.5, 33.7, 33.9, 34.1, 34.6, 35, 35.5, 35.9, 36.4, 36.8, 37.2, 37.6,
    38, 38.3, 38.7, 39.1, 39.4, 39.8, 40.1, 40.5, 40.8, 41.2, 41.5, 41.8, 42.1, 42.4, 42.8, 43.1, 43.4, 43.7, 44, 44.3,
    44.9, 45.5, 46, 46.6, 47.1, 47.7, 48.2, 48.8, 49.3, 49.8, 50.3, 50.8, 51.3, 51.9, 52.4, 52.9, 53.3, 53.8, 54.3, 54.8,
    55.8, 56.7, 57.7, 58.6, 59.5, 60.4, 61.3, 62.2, 63.1, 64, 64.9, 65.8, 66.7, 67.5, 68.4, 69.2, 70.1, 70.9, 71.8, 72.6,
    76.8, 80.8, 84.8, 88.7, 92.5, 96.2, 100, 104, 107, 111, 114, 117, 121, 124, 127, 130, 134, 137, 140, 143, 146, 149,
    152, 155, 158, 160, 163, 166, 169, 171, 174, 177, 180, 182, 185, 187, 190, 192, 195, 197, 200, 202, 205, 207, 210,
    212, 215, 217, 219, 222, 224, 226, 229, 231, 233, 235, 238, 249, 259, 270, 280, 290]

export default class ViscosityService {


    static response = {
        ViscosityDataTable: ""
    };

    static CalculateViscosityConversion(config) {
        ;
        let ViscosityValue = config.viscosity;
        let ViscosityUnit = config.ViscosityType;
        let result = {};
        // this.ValidateViscosityValue(ViscosityUnit, ViscosityValue);
        switch (ViscosityUnit) {
            case VpsViscosityUnit.KinVisc_50C:
                //console.log("KV50Array...",KV50Array)
                result = this.Calculate(KV50Array, parseFloat(ViscosityValue));
                return result;

            case VpsViscosityUnit.Engler:
                result = this.Calculate(EnglerArray, parseFloat(ViscosityValue));
                return result;

            case VpsViscosityUnit.RedWood1:
                result = this.Calculate(RedwoodArray, parseFloat(ViscosityValue));
                return result;

            case VpsViscosityUnit.SSF:
                result = this.Calculate(SSFArray, parseFloat(ViscosityValue));
                return result;

            case VpsViscosityUnit.SSU_122F:
                result = this.Calculate(SSU122Array, parseFloat(ViscosityValue));
                return result;

            case VpsViscosityUnit.SSU_210F:
                result = this.Calculate(SSU210Array, parseFloat(ViscosityValue));
                return result;
        }
    }

    static Calculate(givenViscosityArray, givenViscosityValue) {
        ;

        let val = {
            KinVisc50C: "",
            Engler: "",
            Redwood: "",
            SSF: "",
            SSU122: "",
            SSU210: "",
        }

        for (let k = 0; k <= givenViscosityArray.length; k++) {
            // console.log(givenViscosityArray[k]);
            if (givenViscosityArray[k] >= givenViscosityValue) {
                if (Approximates(givenViscosityArray[k], givenViscosityValue)) {
                    val.KinVisc50C = this.FormatViscosityValue(KV50Array[k], 20, 1)
                    val.Engler = this.FormatViscosityValue(EnglerArray[k], 14, 3)
                    val.Redwood = this.FormatViscosityValue(RedwoodArray[k], 65, 1)
                    if (SSFArray != "") {
                        val.SSF = this.FormatViscosityValue(SSFArray[k], 200, 1)
                    }
                    val.SSU122 = this.FormatViscosityValue(SSU122Array[k], 100, 1)
                    val.SSU210 = this.FormatViscosityValue(SSU210Array[k], 100, 1)
                    //FormatViscosityValue
                    return val;
                }
                else {

                    // 'Interpolate'
                    val.KinVisc50C = this.FormatViscosityValue(this.Interpolate(givenViscosityArray[k], givenViscosityArray[k - 1],
                        KV50Array[k], KV50Array[k - 1], givenViscosityValue), 20, 1)

                    val.Engler = this.FormatViscosityValue(this.Interpolate(givenViscosityArray[k], givenViscosityArray[k - 1],
                        EnglerArray[k], EnglerArray[k - 1], givenViscosityValue), 14, 3)


                    val.Redwood = this.FormatViscosityValue(this.Interpolate(givenViscosityArray[k], givenViscosityArray[k - 1],
                        RedwoodArray[k], RedwoodArray[k - 1], givenViscosityValue), 65, 1)

                    if (SSFArray[k] != "" && SSFArray[k - 1] != "") {
                        val.SSF = this.FormatViscosityValue(this.Interpolate(givenViscosityArray[k], givenViscosityArray[k - 1],
                            SSFArray[k], SSFArray[k - 1], givenViscosityValue), 200, 1)
                    }

                    val.SSU122 = this.FormatViscosityValue(this.Interpolate(givenViscosityArray[k], givenViscosityArray[k - 1],
                        SSU122Array[k], SSU122Array[k - 1], givenViscosityValue), 100, 1)

                    val.SSU210 = this.FormatViscosityValue(this.Interpolate(givenViscosityArray[k], givenViscosityArray[k - 1],
                        SSU210Array[k], SSU210Array[k - 1], givenViscosityValue), 100, 1)
                    return val;
                }
            }
        }
    }


    static Interpolate(upperKnownValue, lowerKnownValue,
        upperRequestedValue, lowerRequestedValue, knownValue) {
        let interpolateValue = (upperRequestedValue - lowerRequestedValue) / (upperKnownValue - lowerKnownValue)

        return ((knownValue - lowerKnownValue) * interpolateValue) + lowerRequestedValue
    }

    static FormatViscosityValue(value, decimalChange, decimals) {
        ;
        let CStr = 1.1;
        let sb = [];
        sb.push("0", CStr.toString().substring(1, 2));
        let valueFormat = "";
        if (value < decimalChange && !Approximates(value, decimalChange)) {
            if (decimals === 1) {
                sb.push("1");
            } else if (decimals === 3) {
                sb.push("0", "0", "1");
            }
            valueFormat = parseFloat(sb.join(""));
            //valueFormat = CDbl(sb.Append("0"c, decimals - 1).ToString & "1")
        } else if (decimals === 1) {
            valueFormat = 1
        } else {
            if (decimals === 1) {
                sb = [];
            } else if (decimals === 3) {
                sb.push("0", "1");
            }
            valueFormat = parseFloat(sb.join(""));
            //valueFormat = parseFloat(sb.push("0", decimals - 2) , "1")
        }
        return RoundValueASTM(value, valueFormat)


    }
}




